import { registerPlugin } from "@capacitor/core";
import type { MonotonicClockPlugin } from "./definitions";

export * from "./definitions";

export const MonotonicClock = registerPlugin<MonotonicClockPlugin>("MonotonicClock", {
  web: async () => new (await import("./web")).MonotonicClockWeb(),
});
